import React, { useState, useCallback, useRef, useEffect } from 'react';

export function useToast() {
  const [toast, setToast] = useState({ message: '', type: 'success', visible: false, exiting: false });
  const timerRef = useRef(null);
  const exitTimerRef = useRef(null);

  const showToast = useCallback((message, type = 'success') => {
    clearTimeout(timerRef.current);
    clearTimeout(exitTimerRef.current);
    setToast({ message, type, visible: true, exiting: false });
    timerRef.current = setTimeout(() => {
      setToast((prev) => ({ ...prev, exiting: true }));
      exitTimerRef.current = setTimeout(() => {
        setToast((prev) => ({ ...prev, visible: false, exiting: false }));
      }, 250);
    }, 2200);
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(exitTimerRef.current);
    };
  }, []);

  return { toast, showToast };
}

const TOAST_ICONS = {
  success: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  error: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  info: null,
};

export default function Toast({ message, type = 'success', visible, exiting }) {
  if (!visible || !message) return null;

  return (
    <div
      className={`toast ${exiting ? 'toast-exit' : ''}`}
    >
      {TOAST_ICONS[type] && TOAST_ICONS[type]}
      {message}
    </div>
  );
}
